export const modules2 = [
  {
    path: "/p/dashboard",
    icon: "dashboard",
    title: "首页",
    meta: { title: "首页", icon: "dashboard", noCache: true },
    group: true,
    collapse: true,
    active: true,
    // children: [
    //   {
    //     path: "/dashboard",
    //     title: "首页",
    //     component: () => import("@/views/dashboard/index"),
    //     name: "dashboard",
    //     meta: { title: "首页", prefix: "/dashboard" },
    //   },
    // ],
  },
  {
    path: "/p/planet",
    title: "星球管理",
    icon: "planet",
    meta: { title: "星球管理", icon: "planet", noCache: true },
    component: () => import("@/views/planet/list"),
    collapse: true,
    children: [
      {
        path: "/p/planet/list",
        title: "星球列表",
        name: "book",
        meta: { title: "星球列表", noCache: true },
      },
      {
        path: "/p/planet/enterGroupList",
        title: "绑定抖音群",
        name: "book",
        meta: { title: "绑定抖音群", noCache: true },
      },
      // ,
      {
        path: "/p/planet/columnGiftList",
        title: "买星球赠课",
        name: "book",
        meta: { title: "买星球赠课", noCache: true },
      },
      // {
      //   path: "/p/planet/messageMention",
      //   title: "配置短信提醒",
      //   name: "book",
      //   meta: { title: "配置短信提醒", noCache: true },
      // },
    ],
  },
  {
    path: "/p/course",
    title: "课程管理",
    icon: "course",
    meta: { title: "课程管理", icon: "course" },
    collapse: true,
    children: [
      // {
      //   path: "/p/course/guide",
      //   title: "买星球赠课",
      //   component: () => import("@/views/course/guide"),
      //   name: "guide",
      //   meta: { title: "买星球赠课" },
      // },
      {
        path: "/p/course/video",
        title: "视频课",
        component: () => import("@/views/course/planetVideo"),
        name: "guide",
        meta: { title: "视频课" },
      },
    ],
  },
  // 教学管理
  //     教学资料
  // {
  //   path: "/teach",
  //   title: "教学管理",
  //   icon: "teaching",
  //   meta: { title: "教学管理", icon: "teaching", noCache: true },
  //   collapse: true,
  //   children: [
  //     // {
  //     //   path: "/teach/teacher",
  //     //   title: "讲师管理",
  //     //   component: () => import("@/views/teaching/teacher"),
  //     //   name: "teacher",
  //     //   meta: { title: "讲师管理", noCache: true },
  //     // },
  //     {
  //       path: "/teach/book",
  //       title: "资料",
  //       component: () => import("@/views/teaching/book"),
  //       name: "book",
  //       meta: { title: "教学资料", noCache: true },
  //     },
  //     {
  //       path: "/teach/courseware",
  //       title: "课件",
  //       component: () => import("@/views/teaching/courseware"),
  //       name: "courseware",
  //       meta: { title: "课件", noCache: true },
  //     },
  //   ],
  // },
  // 营销工具
  //     优惠券
  //     限时抢购
  {
    path: "/p/marketing",
    title: "营销中心",
    icon: "marketing",
    meta: { title: "营销中心", icon: "marketing" },
    group: true,
    collapse: true,
    children: [
      {
        path: "/p/marketing/coupon",
        title: "优惠券",
        component: () => import("@/views/marketing/404"),
        name: "coupon",
        meta: { title: "优惠券" },
      },
      {
        path: "/p/marketing/limited",
        title: "限时抢购",
        component: () => import("@/views/marketing/404"),
        name: "limited",
        meta: { title: "限时抢购" },
      },
      {
        path: "/p/marketing/page",
        title: "店铺装修",
        component: () => import("@/views/marketing/page"),
        name: "page",
        meta: { title: "店铺装修" },
      },
      // {
      //   path: "/marketing/code",
      //   title: "店铺兑换码",
      //   component: () => import("@/views/marketing/code"),
      //   name: "marketingCode",
      //   meta: { title: "店铺兑换码" },
      // },
    ],
  },
  // 订单管理
  {
    path: "/p/order",
    title: "订单管理",
    icon: "order",
    meta: { title: "订单管理", icon: "order" },
    collapse: true,
    children: [
      {
        path: "/p/order/center",
        title: "订单中心",
        component: () => import("@/views/order/orderList"),
        name: "orderCenter",
        meta: { title: "订单中心" },
      },
      // ,
      // {
      //   path: "/p/order/manage",
      //   title: "抖店订单",
      //   component: () => import("@/views/order/manage"),
      //   name: "orderManage",
      //   meta: { title: "抖店订单" },
      // },
    ],
  },
  // 售后管理
  {
    path: "/p/aftersale",
    title: "售后管理",
    icon: "aftersale",
    meta: { title: "售后管理", icon: "aftersale", noCache: true },
    collapse: true,
    children: [
      {
        path: "/p/aftersale/index",
        title: "退款管理",
        component: () => import("@/views/aftersale/index"),
        name: "aftersale",
        meta: { title: "退款管理" },
      },
      {
        path: "/p/aftersale/appeal",
        title: "投诉管理",
        component: () => import("@/views/aftersale/appeal"),
        name: "appeal",
        meta: { title: "投诉管理" },
      },
    ],
  },
  // 用户管理
  {
    path: "/p/user",
    title: "用户管理",
    icon: "user",
    meta: { title: "用户管理", icon: "user", noCache: true },
    collapse: true,
    children: [
      // {
      //   path: "/user/dashboard",
      //   title: "用户概况",
      //   component: () => import("@/views/user/dashboard"),
      //   name: "userDashboard",
      //   meta: { title: "用户概况", noCache: true },
      // },
      {
        path: "/p/user/index",
        title: "用户列表",
        component: () => import("@/views/user/index"),
        name: "userList",
        meta: { title: "用户列表", noCache: true },
      },
      // ,
      // {
      //   path: "/user/groups",
      //   title: "群聊管理",
      //   component: () => import("@/views/user/groups"),
      //   name: "userGroups",
      //   meta: { title: "群聊管理", noCache: true },
      // },
    ],
  },

  // 数据中心
  //     课程分析
  //     学员分析
  //     直播分析
  // {
  //   path: "/database",
  //   title: "数据中心",
  //   icon: "database",
  //   meta: { title: "数据中心", icon: "database", noCache: true },
  //   collapse: true,
  //   children: [
  //     {
  //       path: "/database/course",
  //       title: "课程分析",
  //       component: () => import("@/views/database/course"),
  //       name: "databaseCourse",
  //       meta: { title: "课程分析", noCache: true },
  //     },
  //     {
  //       path: "/database/student",
  //       title: "学员分析",
  //       component: () => import("@/views/database/student"),
  //       name: "databaseStudent",
  //       meta: { title: "学员分析", noCache: true },
  //     },
  //     {
  //       path: "/database/living",
  //       title: "直播分析",
  //       component: () => import("@/views/database/living"),
  //       name: "databaseLiving",
  //       meta: { title: "直播分析", noCache: true },
  //     },
  //     // {
  //     //   path: "/database/costomer",
  //     //   title: "潜客分析",
  //     //   component: () => import("@/views/database/costomer"),
  //     //   name: "databaseCostomer",
  //     //   meta: { title: "潜客分析", noCache: true },
  //     // },
  //   ],
  // },
  // 资金收益
  {
    path: "/p/accounting",
    title: "资金管理",
    icon: "accounting",
    meta: { title: "资金管理", icon: "accounting", noCache: true },
    collapse: true,
    children: [
      {
        path: "/p/accounting/detail",
        title: "资金明细",
        component: () => import("@/views/accounting/index"),
        name: "accountingDetail",
        meta: { title: "资金明细" },
      },
      {
        path: "/p/accounting/balance",
        title: "提现管理",
        component: () => import("@/views/accounting/takeout"),
        name: "accountingBalance",
        meta: { title: "提现管理" },
      },
    ],
  },
  // 新手引导
  {
    path: "/p/setting",
    title: "新手指南",
    icon: "beginner",
    meta: { title: "新手指南", icon: "beginner" },
    collapse: true,
    children: [
      {
        path: "/p/setting/index2",
        title: "抖音资质",
        component: () => import("@/views/setting/index2"),
        name: "accountingSetting2",
        meta: { title: "抖音资质管理" },
      },
      {
        path: "/p/setting/ttScope",
        title: "抖音账号",
        component: () => import("@/views/setting/ttScope"),
        name: "ttScope",
        meta: { title: "抖音账号管理" },
      },
    ],
  },
  {
    path: "/p/setting",
    title: "系统设置",
    icon: "setting",
    meta: { title: "系统设置", icon: "setting" },
    collapse: true,
    children: [
      {
        path: "/p/setting/self",
        title: "账号信息",
        component: () => import("@/views/setting/self"),
        name: "accountingSetting",
        meta: { title: "账号信息" },
      },
      {
        path: "/p/setting/accounting",
        title: "员工管理",
        component: () => import("@/views/setting/manage"),
        name: "accountingManage",
        meta: { title: "员工管理" },
      },
      // {
      //   path: "/setting/record",
      //   title: "导出记录",
      //   component: () => import("@/views/setting/record"),
      //   name: "record",
      //   meta: { title: "导出记录" },
      // },
      {
        path: "/p/setting/role",
        title: "权限管理",
        component: () => import("@/views/setting/role"),
        name: "accountingRole",
        meta: { title: "权限管理" },
      },
    ],
  },
];
